<script setup>

import {storeToRefs} from "pinia";
import {useUserMessageStore} from "@/stores/userMessage.store";
import {onMounted} from "vue";

const userMessageStore = useUserMessageStore();

const fetchDataAndScrollToBottom = async () => {
  await userMessageStore.fetchAll()
  window.scrollTo(0, document.body.scrollHeight)
}

const {messages, userMessage} = storeToRefs(userMessageStore);
const addUserMessage = async () => {
  await userMessageStore.addMessage();
}

onMounted(async () => {
  await fetchDataAndScrollToBottom();
})

</script>

<template>
  <van-space direction="vertical" fill>
    <van-cell-group
        v-for="message in messages"
        :key="message.id"
        inset
    >
      <van-cell :value="message.created_at_formatted">
        <template #title>
          <b>{{ message.owner }}</b>
        </template>
      </van-cell>
      <van-cell>
        <template #title>
          {{ message.text }}
        </template>
      </van-cell>

      <span
          v-for="exerciseSuggestion in message.user_message_exercise_suggestions"
          :key="exerciseSuggestion.id"
      >
            <van-card
                :tag="exerciseSuggestion.exercise.type"
                :title="exerciseSuggestion.exercise.name"
                :desc="exerciseSuggestion.exercise.description"
                :thumb="exerciseSuggestion.exercise.icon_url"
            />
        <van-cell title="Check it out" is-link :url="'/library/' + exerciseSuggestion.exercise.id"/>
      </span>
      <span
          v-for="textSuggestion in message.user_message_text_suggestions"
          :key="textSuggestion.id"
      >
        <van-cell v-if="textSuggestion.text === 'Video'" title="Exercises" is-link to="/library?type=video"/>
        <van-cell v-if="textSuggestion.text === 'Meditation'" title="Meditations" is-link
                  to="/library?type=meditation"/>
        <van-cell v-if="textSuggestion.text === 'Audio'" title="Audios" to="/library?type=audio"/>
        <van-cell v-if="textSuggestion.text === 'Reading'" title="Readings" is-link to="/library?type=reading"/>
        <van-cell v-if="textSuggestion.text === 'Journal'" title="Journals" is-link to="/library?type=journal"/>
      </span>
    </van-cell-group>

    <van-divider/>

    <van-cell-group inset>
      <van-space direction="vertical" fill>
        <van-field
            v-model="userMessage"
            rows="2"
            autosize
            type="textarea"
            maxlength="50"
            placeholder="Please input your message"
            show-word-limit
        />
        <van-button block round type="success" @click="addUserMessage">
          Send
        </van-button>
      </van-space>
    </van-cell-group>

  </van-space>

</template>
